import React from "react";
import Image from "next/image";
import { useAppContext } from "@/context/Context";
import { useEffect, useState } from "react";

function CountBanner() {
  const [isMobile, setIsMobile] = React.useState(false);
  const { isLightTheme } = useAppContext();
  const [count, setCount] = useState(null);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}/getdashboarddetails`
        );
        const data = await res.json();
        console.log("data ", data);
        setCount(data.data);
      } catch (err) {
        console.log("Error in fetching", err);
      }
    };

    fetchdata();
  }, []);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardBg = isLightTheme
    ? "rgba(255, 255, 255, 0.95)"
    : "rgba(42, 42, 62, 0.95)";

  const titleColor = isLightTheme ? "#2d3748" : "var(--color-white-off)";

  const countAccentColor = "#A259E0";

  const descriptionColor = isLightTheme ? "#4a5568" : "var(--rbt-color-body)";

  const imageFilter = "grayscale(100%)";

  const logo = isLightTheme
    ? "https://user-gen-media-assets.s3.amazonaws.com/gpt4o_images/79ecd538-d3b2-4e57-868d-9b8843894f54.png"
    : "/MainHome/one11.png";

  const logo1 = isLightTheme
    ? "https://user-gen-media-assets.s3.amazonaws.com/gpt4o_images/639d5a59-6f61-4fe0-b0c4-3131d846be32.png"
    : "/MainHome/two2.png";

  const logo3 = isLightTheme
    ? "https://user-gen-media-assets.s3.amazonaws.com/gpt4o_images/9f52982a-0787-4b7d-9225-a2412d9ca365.png"
    : "/MainHome/second1.png";

  return (
    <div
      style={{
        position: "relative",

        height: "0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-160px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "calc(100% - 40px)",
          maxWidth: "800px",
          padding: isMobile ? "20px 10px" : "30px 20px",
        }}
      >
        {/* Title */}
        {/* <h2
          style={{
            fontWeight: "bold",
            marginBottom: isMobile ? "25px" : "35px",
            textAlign: "center",
            fontSize: isMobile ? "1.5rem" : "2.2rem",
            color: titleColor,
            lineHeight: "1.3",
            textShadow: isLightTheme 
              ? "0 2px 10px rgba(0, 0, 0, 0.1)" 
              : "0 2px 10px rgba(0, 0, 0, 0.5)",
          }}
        >
          Trusted by Students and Parents Alike
        </h2> */}

        {/* Stats Container - Horizontal Scroll on Mobile */}
        <div
          style={{
            display: "flex",
            justifyContent: isMobile ? "flex-start" : "center",
            alignItems: "stretch",
            gap: isMobile ? "20px" : "30px",
            overflowX: isMobile ? "auto" : "visible",
            overflowY: "hidden",
            padding: isMobile ? "10px " : "15px",
            scrollbarWidth: "thin",
            scrollbarColor: `${countAccentColor} transparent`,
            // backgroundColor:'black'
          }}
        >
          {/* Stat 1 Card */}
          <div
            style={{
              textAlign: "center",

              flex: isMobile ? "0 0 auto" : "1",
              background: cardBg,
              borderRadius: "20px",
              padding: isMobile ? "25px 15px" : "40px 20px",
              boxShadow: isLightTheme
                ? "0 10px 30px rgba(0, 0, 0, 0.12)"
                : "0 10px 30px rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(10px)",
              border: isLightTheme
                ? "1px solid rgba(162, 89, 224, 0.15)"
                : "1px solid rgba(162, 89, 224, 0.25)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = isLightTheme
                ? "0 15px 40px rgba(0, 0, 0, 0.15)"
                : "0 15px 40px rgba(0, 0, 0, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = isLightTheme
                ? "0 10px 30px rgba(0, 0, 0, 0.12)"
                : "0 10px 30px rgba(0, 0, 0, 0.4)";
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                margin: "0 auto 15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `linear-gradient(135deg, ${countAccentColor}20, ${countAccentColor}08)`,
                borderRadius: "50%",
                padding: "20px",
              }}
            >
              <Image
                src={logo}
                alt="Instructors"
                width={50}
                height={50}
                style={{ filter: imageFilter }}
              />
            </div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "2rem",
                marginBottom: "8px",
                color: countAccentColor,
              }}
            >
              {count?.totalInstructor}
            </div>
            <div
              style={{
                color: descriptionColor,
                fontSize: "1.5rem",
                fontWeight: "500",
              }}
            >
              Instructors
            </div>
          </div>

          {/* Stat 2 Card */}
          <div
            style={{
              textAlign: "center",

              flex: isMobile ? "0 0 auto" : "1",
              background: cardBg,
              borderRadius: "20px",
              padding: isMobile ? "25px 15px" : "40px 20px",
              boxShadow: isLightTheme
                ? "0 10px 30px rgba(0, 0, 0, 0.12)"
                : "0 10px 30px rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(10px)",
              border: isLightTheme
                ? "1px solid rgba(162, 89, 224, 0.15)"
                : "1px solid rgba(162, 89, 224, 0.25)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = isLightTheme
                ? "0 15px 40px rgba(0, 0, 0, 0.15)"
                : "0 15px 40px rgba(0, 0, 0, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = isLightTheme
                ? "0 10px 30px rgba(0, 0, 0, 0.12)"
                : "0 10px 30px rgba(0, 0, 0, 0.4)";
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                margin: "0 auto 15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `linear-gradient(135deg, ${countAccentColor}20, ${countAccentColor}08)`,
                borderRadius: "50%",
                padding: "20px",
              }}
            >
              <Image
                src={logo3}
                alt="Students"
                width={50}
                height={50}
                style={{ filter: imageFilter }}
              />
            </div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "2rem",
                marginBottom: "8px",
                color: countAccentColor,
              }}
            >
              {count?.totalStudents}
            </div>
            <div
              style={{
                color: descriptionColor,
                fontSize: "1.5rem",
                fontWeight: "500",
              }}
            >
              Candidates
            </div>
          </div>

          {/* Stat 3 Card */}
          <div
            style={{
              textAlign: "center",

              flex: isMobile ? "0 0 auto" : "1",
              background: cardBg,
              borderRadius: "20px",
              padding: isMobile ? "25px 15px" : "40px 20px",
              boxShadow: isLightTheme
                ? "0 10px 30px rgba(0, 0, 0, 0.12)"
                : "0 10px 30px rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(10px)",
              border: isLightTheme
                ? "1px solid rgba(162, 89, 224, 0.15)"
                : "1px solid rgba(162, 89, 224, 0.25)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = isLightTheme
                ? "0 15px 40px rgba(0, 0, 0, 0.15)"
                : "0 15px 40px rgba(0, 0, 0, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = isLightTheme
                ? "0 10px 30px rgba(0, 0, 0, 0.12)"
                : "0 10px 30px rgba(0, 0, 0, 0.4)";
            }}
          >
            <div
              style={{
                width: "80px",
                height: "80px",
                margin: "0 auto 15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `linear-gradient(135deg, ${countAccentColor}20, ${countAccentColor}08)`,
                borderRadius: "50%",
                padding: "20px",
              }}
            >
              <Image
                src={logo1}
                alt="HR"
                width={50}
                height={50}
                style={{ filter: imageFilter }}
              />
            </div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "2rem",
                marginBottom: "8px",
                color: countAccentColor,
              }}
            >
              {count?.totalHRs}
            </div>
            <div
              style={{
                color: descriptionColor,
                fontSize: "1.5rem",
                fontWeight: "500",
              }}
            >
              HR
            </div>
          </div>
        </div>

        {/* Custom Scrollbar Styles - Only for Mobile */}
        <style jsx>{`
          div::-webkit-scrollbar {
            height: 6px;
          }
          div::-webkit-scrollbar-track {
            background: transparent;
          }
          div::-webkit-scrollbar-thumb {
            background: ${countAccentColor};
            border-radius: 3px;
          }
          div::-webkit-scrollbar-thumb:hover {
            background: ${countAccentColor}dd;
          }
        `}</style>
      </div>
    </div>
  );
}

export default CountBanner;
